

import styles from './linksModal.module.css';
import CloseIcon from '@mui/icons-material/Close';
import BaroqueSeparator from './UI/BaroqueSeparator';
import GoldLineSeparator from './UI/GoldLineSeparator';
import Button from './UI/Button';

import { Link } from 'react-router-dom';

const LinksModal = (props) => {

   

    return (
        <div className = {styles.container} style = {{top: 0, left: 0}}>
            
            <CloseIcon sx = {{width: '50px', height: '50px'}} className = {styles.close} onClick = {props.onModalClose}/>
        <div className={props.isOn ? styles.linksBox : styles.linksBoxClosing}>
            <h1 className = {styles.title}>Weiterführende Links</h1>
            <GoldLineSeparator width= '60%' />
            <BaroqueSeparator />
            <ul>
            <li>
                <Link to='https://alessio.nocita.photo' className={styles.link}>Alessio Nocita Photographie</Link>
            </li>
            <li>
                <Link to='https://www.alessio-nocita.com' className={styles.link}>Alessio Nocita - Musiker Seite</Link>
            </li>
            <li>
                <Link to='https://www.facebook.com' className={styles.link}>Facebook</Link>
            </li>
            <li>
                <Link to='https://www.instagram.com>' className={styles.link}>Instagram</Link>
            </li>
            <li>
                <Link to='https://www.faz.net' className={styles.link}>Frankfurter Allgemeine</Link>
            </li>
            <li>
                <Link to='https://www.sueddeutsche.de' className={styles.link}>Süddeutsche Zeitung</Link>
            </li>
            </ul>
            <Button onClickFunction = {props.onModalClose}>Schließen</Button>
            </div>

            
        </div>
    )
}

export default LinksModal;